module.exports = __webpack_public_path__ + "static/media/Cash-Payment-Unpaid.fec2b08d.png";